module.exports = __webpack_public_path__ + "media/images/placeholders/table_placeholder-7e11cc57163146cc09eb3aa933e250a7.png";